import { Col, Row } from 'antd';
import React from 'react';
import strings from '../../eyeguide-localization/reports/string.filter';

const genderOptions = [{label: 'Female', value: '0'}, {label: 'Male', value: '1'}, 
                       {label: 'Other', value: '2'}, {label: 'Unspecified', value: '3'}];

interface ICustomFilter {
    firstname: string | null;
    lastname: string | null;
    middlename: string | null;
    profileID: string | null;
    score: Array<any> | null;
    sport: string | undefined;
    level: string | undefined;
    gender: Array<any> | undefined;
    range: string | undefined;
}

interface IFilterProps {
    custom: ICustomFilter;
    hidden: boolean | undefined;
}

interface IFilterState {

}

class FilterList extends React.Component<IFilterProps, IFilterState> {
    
    constructor(props: IFilterProps) {
        super(props);
    }

    render() {
        var custom = this.props.custom;
        return (
            <Col hidden={this.props.hidden} style={{width: '100%'}}>
                <Row>&nbsp;</Row>
                <Row type="flex">
                    <Col className="filterCard-2-Row">
                        <Row className="filterHeader allCheckRow">{strings.isCustomTxt}</Row>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row hidden={!custom.firstname} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isFirstnameTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>{custom.firstname}</Row>
                    </Col>
                </Row>
                <Row hidden={!custom.middlename} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isMiddlenameTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>{custom.middlename}</Row>
                    </Col>
                </Row>
                <Row hidden={!custom.lastname} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isLastnameTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>{custom.lastname}</Row>
                    </Col>
                </Row>
                <Row hidden={!custom.profileID} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isIdTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>{custom.profileID}</Row>
                    </Col>
                </Row>
                <Row hidden={!custom.score} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isTestScore}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>{custom.score ? custom.score.join(' - ') : undefined}</Row>
                    </Col>
                </Row>
                <Row hidden={!custom.sport} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isSportTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>{custom.sport}</Row>
                    </Col>
                </Row>
                <Row hidden={!custom.level} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isLevelTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>{custom.level}</Row>
                    </Col>
                </Row>
                <Row hidden={!(custom.gender && custom.gender.length > 0)} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isGenderTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row >{this.renderGenders(custom.gender)}</Row>
                    </Col>
                </Row>
                <Row hidden={!(custom.range && custom.range.length > 0)} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isTestThreshold}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>{custom.range}</Row>
                    </Col>
                </Row>
            </Col>
        );
    }

    private renderGenders = (genders: Array<any> | undefined) => {
        return genders ? (genders.map(
            (g) => {
                var r = genderOptions.find((e) => e.value === g );
                return r ? r.label : '';
            }
        )).join(', ') : null;
    }
}

export default FilterList;


// WEBPACK FOOTER //
// ./src/components/reports/reports.filterlist.tsx